import http from "@/core/services/http.service";

const PoliceBookService = {
    async getPoliceBooksReports(params) {
        return http.get(`/api/v1/police-books/`, {params});
    },
    async removePoliceBookReport(uuid) {
        return http.delete(`/api/v1/police-books/${uuid}`);
    },
    async generatePoliceBookReport(params) {
        return http.post(`/api/v1/police-books/generate-new-report/`, params);
    },
    async getPoliceBookPDFUrl(uuid) {
        return http.get(`/api/v1/police-books/pdf-url/${uuid}`);
    },
};

export default PoliceBookService;